import createIcon from '../../createIcon';

/**
 * @component @name SignalWifiConnectedNoInternet4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjQgOC40OEMyMC45MyA1LjQgMTYuNjkgMy41IDEyIDMuNUM3LjMxIDMuNSAzLjA3IDUuNCAwIDguNDhMMTIgMjAuNVYxMS41SDIwLjk5TDI0IDguNDhaTTE5LjU5IDEzLjVMMTcuNSAxNS41OUwxNS40MSAxMy41TDE0IDE0LjkxTDE2LjA5IDE3TDE0IDE5LjA5TDE1LjQxIDIwLjVMMTcuNSAxOC40MkwxOS41OSAyMC41TDIxIDE5LjA5TDE4LjkyIDE3TDIxIDE0LjkxTDE5LjU5IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifiConnectedNoInternet4 = createIcon('SignalWifiConnectedNoInternet4', [
  [
    'path',
    {
      d: 'M24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5V11.5H20.99L24 8.48ZM19.59 13.5L17.5 15.59L15.41 13.5L14 14.91L16.09 17L14 19.09L15.41 20.5L17.5 18.42L19.59 20.5L21 19.09L18.92 17L21 14.91L19.59 13.5Z',
      key: '1yclsi',
    },
  ],
]);

export default SignalWifiConnectedNoInternet4;
